module.exports = __webpack_public_path__ + "static/media/Mary K. Lawler@2x.8809a1ac.jpg";